const months = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC'
];

// formats to JAN 1, 2025
export default function formatDate(dateString: string): string {
  const [year, month, day] = dateString.split('T')[0].split('-');

  return `${months[parseInt(month, 10) - 1]} ${parseInt(day, 10)}, ${year}`;
}
